import { Injectable, OnInit, Output } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { EstatusJSON } from "../../../../shared/models/EstatusJSON";
import { ValetParkingMapComponent } from "../components/3-panel-detail-locations/organisms/valet-parking-map/valet-parking-map.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ValetParkingMapService } from "./ValetParkingMap.service";

import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ValetParkingService {
  
  private dialogRef: MatDialogRef<ValetParkingMapComponent> | null = null;
 
  DataGeoJson$: Subject<EstatusJSON> = new Subject<EstatusJSON>();
  
  constructor(private dialog: MatDialog, private valetParkingMapService: ValetParkingMapService) {
  }

  openDialog(identifier: any, description: any): any {
    if (!this.dialogRef) {
      this.dialogRef = this.dialog.open(ValetParkingMapComponent, {
        width: '600px',
        data: { identificador: identifier, descripcion: description },
        hasBackdrop: false,
        disableClose: true,
        position: {
          bottom: '0px'
        },
        panelClass: 'custom-dialog-container'
      });

      this.dialogRef.afterClosed().subscribe((data) => {
        this.dialogRef = null;
      });

      return this.dialogRef;
    }
  }

  closeDialog() {
    if(!environment.production) console.log('valet', this.dialogRef);
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }

  setExistsValetParking(exists: boolean){
    this.valetParkingMapService.existValetParking = exists;
  }

  assignValetParkingValues(data: any){
    this.valetParkingMapService.existValetParking = true;
    this.valetParkingMapService.coordsValetParking = { lat: parseFloat(data.result.geom_CentroidY), lng: parseFloat(data.result.geom_CentroidX) };
    this.valetParkingMapService.bufferRadioKm = parseFloat(data.result.radio);
    this.valetParkingMapService.UpdateValetParkingBuffer();
  }

  unassignValetParkingValues(){ 
    this.valetParkingMapService.existValetParking = false;
    this.valetParkingMapService.coordsValetParking = { lat: 90, lng: 90 };
    this.valetParkingMapService.bufferRadioKm = 0.1;
    this.valetParkingMapService.UpdateValetParkingBuffer();
  }

  deleteValetParking(isDeleted: boolean, locationDTO: any){
    this.valetParkingMapService.existValetParking = !isDeleted;
    this.valetParkingMapService.DeleteValetParkingDragEvent();
    this.valetParkingMapService.ResetValetParkingActiveBuffer();
    this.valetParkingMapService.coordsValetParking = { lat: parseFloat(locationDTO.cordsY), lng: parseFloat(locationDTO.cordsX) };
  }

  stopValetParkingCreation(){
    this.valetParkingMapService.DeleteValetParkingDragEvent();
    this.valetParkingMapService.ResetValetParkingActiveBuffer();
    this.closeDialog();
  }

}
